/* eslint-disable array-callback-return */
import { Modal } from "react-bootstrap";
import {
  popCancelBttn,
  exclaimIcn,
  imsLoader
} from "../../assets";
import { Component } from "react";
import Button from "../Button";
import ApiServices from "../../utils/apiServices";
import RenamePubMedReviewListPopup from "./RenamePubMedReviewListPopup";
import { v4 as uuidv4 } from "uuid";
import SucessReadingList from "./SucessReadingList";
import { snippetLongString, LocationOrigin, getCurrentDate } from "../../utils/utilityServices";
import "./GlobalSearchFeaturesPopUp.css";
import "./PubMedReviewListPopup.css";
import AlertMessagePopUpModal from "./AlertMessagePopUpModal";
import ConfirmMessagePopUpModal from "./ConfirmMessagePopUpModal"
import moment from 'moment';
import axios from "axios";
import trackingService from "../../services/trackingService";
import { Authentication } from "../../utils/authenticationUtilityServices";
import SharePubMedModal from "./SharePubmedModal";
let _locationOrigin = LocationOrigin;
//_locationOrigin = 'https://predev-ims.jnj.com';
class PubMedReviewListPopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showPop: false,
      isPin: true,
      isinfo: true,
      isManage: false,
      apiResponse: [],
      isLoaded: false,
      showRenamePop: false,
      itemtoBeRenamedName: "",
      itemtoBeRenamedID: "",
      error: "",
      reviewListName: "",
      docID: [],
      showSuccess: false,
      isInsertSuccess: false,
      selectedReviewLists: [],
      successMessage: "",
      nodeName: "",
      alertMessageModelColor: "",
      alertMessageContent: "",
      alertMessageShowModal: false,
      confirmMessageContent: '',
      confirmMessageShowModal: false,
      confirmMessageId: -1,
      selectedTab: this.props.selectedTab,
      useTemplate: this.props.useTemplate,
      notes: "",
      shareModal: false,
      shareReviewList: ''

    };
  }
  async componentDidMount() {
    let username = JSON.parse(localStorage.getItem("username")).toLowerCase();
    let service = new ApiServices();
    if (
      this.props.selectedResults.length <= 0
      //this.props.selectedResults.length > 200
    ) {
      this.setState({
        isManage: true,
        isPin: false,
        isinfo: false,
      });
    } else {
      this.setState({
        docID: this.props.selectedResults.map((item) => item.detail.rli_id),
      });
    }
    this.setState({
      showPop: this.props.showModal,
    });
    let apiRes = await service.getPubMedReviewLists(username);
    this.setState(
      {
        apiResponse: apiRes,
        //isLoaded: true
      },
      async () => {
        await this.getPubMedReviewListsWithDocIds();
      }
    );
  }

  showConfirmMessage = (message, id) => {
    this.setState({
      confirmMessageContent: message,
      confirmMessageShowModal: true,
      confirmMessageId: id
    })
  }

  confirmHandler = async () => {
    const { confirmMessageId } = this.state;
    let username = JSON.parse(localStorage.getItem('username'))
    if (username) {
      username = username.toLowerCase();
    }
    let service = new ApiServices();
    let deleteRes = await this.deletereviewListByReviewListId(confirmMessageId);
    if (deleteRes.statusCode === 200) {
      await service.deletePubMedReviewLists(confirmMessageId, username);
      this.setState(
        {
          isLoaded: false,
          confirmMessageContent: "",
          confirmMessageShowModal: false,
          confirmMessageId: -1
        },
        async () => {
          let { selectedReviewLists } = this.state
          let apiRes = await service.getPubMedReviewLists(username);
          let reviewlistIds = apiRes.map(x => x.reviewlist_id);
          selectedReviewLists = selectedReviewLists.filter(x => reviewlistIds.includes(x.reviewlist_id));
          this.setState(
            {
              apiResponse: apiRes,
              isLoaded: true,
              selectedReviewLists: selectedReviewLists
            },
            async () => {
              await this.getPubMedReviewListsWithDocIds();
              this.props.handleRemoveReviewList(confirmMessageId)
            }
          );
        }
      );
    } else {
      this.setState(
        {
          confirmMessageContent: "",
          confirmMessageShowModal: false,
          confirmMessageId: -1
        }, () => {

          this.errorAlertMessage("Something Went Wrong. Kindly try after some time.");
        })
    }

  }
  deletereviewListByReviewListId = async (reviewListId) => {
    var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}reviewlist/drlbyreviewListId?reviewListId=${reviewListId}`
    //url = `http://localhost:2888${process.env.REACT_APP_IMS_API_PUBMED}reviewlist/drlbyreviewListId?reviewListId=${reviewListId}`
    let res = { "statusCode": 500 };
    const _headers = {
      'Content-Type': 'application/json'
    };
    if (await Authentication.isAccessTokenAvailable()) {
      // No Authorization header provided, attach the default one
      const token = await Authentication.getAccessToken();
      _headers.Authorization = `Bearer ${token}`;
    }
    await axios
      .delete(url, { headers: _headers })
      .then((response) => {
        res = response.data;
      })
      .catch((error) => {
        console.log(error);
        res = { "statusCode": 500 };
      });
    return res;
  }
  closeConfirmMessage = () => {
    this.setState({
      confirmMessageContent: "",
      confirmMessageShowModal: false,
      confirmMessageIndex: -1
    })
  }
  errorAlertMessage = (message) => {
    this.setState({
      alertMessageContent: message,
      alertMessageModelColor: "#de1327",
      alertMessageShowModal: true
    })
  }

  closeAlertMessage = () => {
    this.setState({
      alertMessageContent: "",
      alertMessageModelColor: "",
      alertMessageShowModal: false
    })
  }
  getPubMedReviewListsWithDocIds = async () => {
    let { apiResponse } = this.state;
    let username = JSON.parse(localStorage.getItem("username")).toLowerCase();
    let service = new ApiServices();
    let apiRes = await service.getPubMedReviewListsWithDocIds(username);
    let doneArr = [];
    if (apiRes) {
      apiRes.map((item) => {
        let _docCount = item.doc_id.split(";").length;
        if (!doneArr.find((x) => x === item.reviewlist_id)) {
          _docCount += this.props.selectedResults.length;

          let _selectedReviewList = apiResponse.find(
            (x) => x.reviewlist_id === item.reviewlist_id
          );

          _selectedReviewList.docCount =
            _selectedReviewList.docCount === undefined
              ? _docCount
              : _selectedReviewList.docCount + _docCount;

          _selectedReviewList.doc_id = item.doc_id;
        } else {
          let _selReadList = apiResponse.find(
            (x) => x.reviewlist_id === item.reviewlist_id
          );

          _selReadList.doc_id =
            _selReadList.doc_id !== undefined
              ? _selReadList.doc_id + ";" + item.doc_id
              : item.doc_id;

          _selReadList.doc_id = Array.from(
            new Set(_selReadList.doc_id.split(";"))
          );

          _selReadList.docCount =
            _selReadList.doc_id.length + this.props.selectedResults.length;
        }

        doneArr.push(item.reviewlist_id);
      });
      this.setState({
        apiResponse: apiResponse,
        isLoaded: true,
      });
    }
  };

  handleOnClickView = async (rlID, rName) => {
    let ids = "";
    //this.props.handleReviewNameTitle(rName,rlID)
    //console.log({props: this.props})
    this.props.getAllReviewListData(rlID, "", rName)
    this.props.handleClose()
    //let service = new ApiServices();
    // console.log({rlID, rName})
    // let res = await fetch(`https://predev-ims.jnj.com${process.env.REACT_APP_IMS_API_PUBMED}reviewlist`, {
    //   method: 'POST',
    //   headers: {
    //     "Content-Type": "application/json"
    //   },
    //   body: JSON.stringify({
    //     "filters": "",
    //     "from_": 0,
    //     "size": 25,
    //     "sortBy": "",
    //     "sortField": "",
    //     "query": "",
    //     "reviewListId": rlID
    //   })
    // })
    // res = await res.json()
    // console.log({res})
    // let res = await service.getPubMedReviewDocIds(rlID);
    // console.log({res})
    // if (res.length > 0) {
    //   ids = res.map(item => item.doc_id).filter(x => x).join(";");
    //   // res.map((item) => {
    //   //   ids += `${item.doc_id};`;
    //   //   return null;
    //   // });
    // }
    localStorage.setItem("readListDocIds", ids);
    localStorage.setItem("rLID", rlID);
    localStorage.setItem("rName", rName);
    // let url = `/viewPubMedReviewList?query=&q=All%20Fields&filters=&f1=PMID&fval1=${ids}&fcount=1&rName=${encodeURIComponent(
    //   rName
    // )}&rID=${rlID}`;
    // if (ids !== "") {
    //   window.open(url, "_blank");
    // } else {
    //   this.errorAlertMessage("You do not have any items pinned to this review list.");
    // }
  };
  handleRename = (id, name, reviewlistNote) => {
    this.setState({
      showRenamePop: true,
      itemtoBeRenamedName: name,
      itemtoBeRenamedID: id,
      notes: reviewlistNote
    });
  };
  handleRenameClose = (status) => {
    this.setState(
      {
        showRenamePop: status,
        isLoaded: false,
      },
      async () => {
        let username = JSON.parse(
          localStorage.getItem("username")
        ).toLowerCase();
        let service = new ApiServices();
        let apiRes = await service.getPubMedReviewLists(username);
        this.setState(
          {
            apiResponse: apiRes,
            //isLoaded: true
          },
          async () => {
            await this.getPubMedReviewListsWithDocIds();
          }
        );
      }
    );
  };
  handleRemove = async (id) => {
    this.showConfirmMessage("Are you sure you want to delete this review list ?", id)
  };
  handleValidation() {
    let errors = {};
    let formIsValid = true;
    let reviewList = this.state.apiResponse.map((data) =>
      data.reviewlist_name.toLowerCase()
    );
    if (
      this.state.reviewListName.length <= 0 &&
      this.state.selectedReviewLists.length <= 0 &&
      this.state.nodeName !== "INPUT"
    ) {
      formIsValid = false;
      this.errorAlertMessage("Please enter either New Review List name or select any Existing review list to proceed.")
      // errors["pinReviewList"] = 'Please enter a valid name to proceed.';
    }
    if (
      this.state.reviewListName.length <= 0 &&
      this.state.nodeName === "INPUT" &&
      this.state.selectedReviewLists.length <= 0
    ) {
      formIsValid = false;
      errors["pinReviewList"] = `Please enter a valid name to proceed.`;
    }
    if (reviewList.includes(this.state.reviewListName.toLowerCase())) {
      formIsValid = false;
      errors[
        "pinReviewList"
      ] = `You already have a review list with entered title. Please enter a new title.`;
    }
    this.setState({ error: errors });
    return formIsValid;
  }
  handleCheckBox = (e, itemCounts) => {
    /*if (itemCounts <= 200 || itemCounts === undefined) {*/
    let arr = this.state.selectedReviewLists;
    if (e.target.checked) {
      arr.push(e.target.value);
    } else {
      var idx = arr.indexOf(e.target.value);
      if (idx !== -1) {
        arr.splice(idx, 1);
      }
    }
    this.setState({
      selectedReviewLists: arr,
    });

    /*} else {
      e.preventDefault();
      e.returnValue = false;
      this.errorAlertMessage("A user may only add a maximum of 200 items in a review list.");
    }*/

  };
  handleOnFocusInput = (e) => {
    this.setState({ nodeName: e.target.nodeName });
  };
  handleInput = (e) => {
    e.target.value = snippetLongString(e.target.value);
    this.setState({
      reviewListName: e.target.value,
    });
  };
  indexData = (reviewListName, reviewListId, docIDs, transactionId) => {
    let { useTemplate } = this.state;
    let _reviewListinfo = {
      reviewListName: reviewListName,
      reviewListId: reviewListId,
      docIDs: docIDs,
      transactionId: transactionId
    }
    let _eventaction = 'Save Review List';
    if (this.state.selectedTab === '0') {
      _eventaction = "Save Review List PubMedGenAI2.0 in PubMed Tab";
    }
    else if (this.state.selectedTab === '1') {
      _eventaction = `Save Review List PubMedGenAI2.0 with ${useTemplate} Template in Upload Abstracts Tab`;
    }
    else if (this.state.selectedTab === '2') {
      _eventaction = "Save Review List PubMedGenAI2.0 in Review List Tab";
    }
    else if (this.state.selectedTab === '3') {
      _eventaction = "Save Review List PubMedGenAI2.0 in Saved Searches Tab";
    }
    const ts = new trackingService();
    ts.indexTrackingData(localStorage.getItem('userdisplayName'),
      localStorage.getItem('wwid'),
      localStorage.getItem('username'),
      localStorage.getItem('function'),
      localStorage.getItem('region'),
      localStorage.getItem('userproducts'),
      localStorage.getItem('doctypepref'),
      localStorage.getItem('sid'),
      localStorage.getItem('deviceType'),
      localStorage.getItem('deviceOS'),
      localStorage.getItem('browserName'),
      localStorage.getItem('browserVersion'),
      localStorage.getItem('jnjDepartment'),
      localStorage.getItem('companyname'),
      _eventaction,
      '',
      window.location.href, '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', {}, {}, {}, {}, _reviewListinfo);
  }
  onclickProceed = async () => {
    let username = JSON.parse(localStorage.getItem("username")).toLowerCase();
    let service = new ApiServices();
    let docIDs = this.state.docID.join(";");
    let isValidReviewList = true;
    if (this.handleValidation()) {
      if (this.state.reviewListName !== "") {
        this.setState({ isLoaded: false });
        //this.props.handleReviewNameTitle(this.state.reviewListName)
        let listID = uuidv4();
        let reviewListItems = [];
        let _transaction_id = uuidv4();
        this.props.selectedResults.map((item) => {
          reviewListItems.push({
            ...item.detail,
            reviewListName: this.state.reviewListName,
            reviewListId: `RL_${listID}`,
            transaction_id: _transaction_id,
            reviewListType: this.state.selectedTab === "0" ? "PubMed" : "Abstracts",
            username: username,
            lastCreatedDatehour: getCurrentDate()
          })
        })

        let pubmedReviewResponse = await this.insertPubmedReviewListData(reviewListItems, _transaction_id);
        if (!pubmedReviewResponse.errors) {
          await service.insertUpdatePubMedReviewList(
            this.state.reviewListName,
            `RL_${listID}`,
            username,
            docIDs,
            this.state.notes
          );

          this.indexData(this.state.reviewListName, `RL_${listID}`, docIDs, _transaction_id)
          this.setState({ isLoaded: true });
          this.setState({
            successMessage:
              "The result/selection was pinned successfully to new Review List.",
            showSuccess: true,
            isInsertSuccess: true
          });

        } else {
          isValidReviewList = false;
          if (!isValidReviewList) {
            this.setState({ isLoaded: true }, () => {
              this.errorAlertMessage(`Something Went Wrong. Kindly try after some time.`)
            });

          }

        }

      }
      if (this.state.selectedReviewLists.length > 0) {
        try {
          this.setState({ isLoaded: false });
          /** 
          *  find all existing review list records
          */
          let data = {
            reviewListIds: this.state.selectedReviewLists,
          }
          let url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}reviewlist/gprld`;
          if (window.location.origin === "https://predev-ims.jnj.com") {
            url = `${window.location.origin}${process.env.REACT_APP_IMS_API_PUBMED}reviewlist/gprld`;
          }
          //const _locationOrigin = 'https://predev-ims.jnj.com'
          //const url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}reviewlist/gprld`

          const _headers = {
            'Content-Type': 'application/json'
          };
          if (await Authentication.isAccessTokenAvailable()) {
            // No Authorization header provided, attach the default one
            const token = await Authentication.getAccessToken();
            _headers.Authorization = `Bearer ${token}`;
          }
          const res = await axios.post(url, data,
            {
              headers: _headers
            })
          const obj = {}
          res.data.forEach(data => {
            if (data.reviewListId in obj) {
              obj[data.reviewListId].push(data)
            } else {
              obj[data.reviewListId] = [data]
            }
          })

          /**
           * remove duplicates from existing reviewlist
           */
          const reviewListWithoutDuplicates = {}
          let duplicates_present = false
          this.props.selectedResults.forEach((data) => {
            Object.keys(obj).forEach(reviewList_id => {
              const res = obj[reviewList_id].find((data2) => {
                if (data2?.PMID && data.detail?.PMID && data2.PMID == data.detail.PMID) {
                  return true
                } else if (data2?.title && data.detail?.title && data2.title == data.detail.title) {
                  return true
                }
                return false
              })

              if (!res) {
                if (reviewList_id in reviewListWithoutDuplicates) {
                  reviewListWithoutDuplicates[reviewList_id].push(data)
                } else {
                  reviewListWithoutDuplicates[reviewList_id] = [data]
                }
              } else {
                duplicates_present = true
              }
            })
          })
          //console.log({res, obj, selectedResults: this.props.selectedResults, reviewListWithoutDuplicates})          

          /**
           * remove duplicates from existing reviewlist
           * @reviewListWithoutDuplicates only contains records that needed to be added into review list
          */
          let failedReviewList = [];
          Object.keys(reviewListWithoutDuplicates).forEach(async (reviewList_id) => {
            const rl = this.state.apiResponse.find((e) => e.reviewlist_id === reviewList_id);
            let _transaction_id = uuidv4();
            const reviewListItems = []
            reviewListWithoutDuplicates[reviewList_id].forEach((record) => {
              reviewListItems.push({
                ...record.detail,
                reviewListName: rl.reviewlist_name,
                reviewListId: reviewList_id,
                transaction_id: _transaction_id,
                reviewListType: this.state.selectedTab === "0" ? "PubMed" : "Abstracts",
                username: username,
                lastCreatedDatehour: getCurrentDate()
              })
            })

            let pubmedReviewResponse = await this.insertPubmedReviewListData(reviewListItems, _transaction_id);
            //console.log({pubmedReviewResponse, reviewList_id, reviewListItems})
            if (!pubmedReviewResponse.errors) {
              await service.insertUpdatePubMedReviewList(
                rl.reviewlist_name,
                reviewList_id,
                username,
                docIDs,
                this.state.notes
              );
              this.indexData(rl.reviewlist_name, reviewList_id, docIDs, _transaction_id)
            } else {
              isValidReviewList = false;
              failedReviewList.push(rl.reviewlist_name);
            }
          })

          this.setState({ isLoaded: true }, () => {
            if (!isValidReviewList) {
              this.errorAlertMessage(`Add to reviewlist failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Review list name</p> - ${failedReviewList.join("<br /> - ")}`)
            } else {
              let successMessage = "The result/selection was pinned successfully to selected existing Review List(s)."
              if (duplicates_present) {
                successMessage = `The result/selection was pinned successfully to selected existing Review List(s),
                 Some of the duplicates recrods are ignored`
              }
              this.setState({
                successMessage,
                showSuccess: true,
                isInsertSuccess: true
              });
            }
          });
        } catch (err) {
          console.log({ err })
          this.errorAlertMessage("Add to reviewlist failed due to some reason. Kindly try after some time.");
        } finally {
          this.setState({ isLoaded: true });
        }

        // let failedReviewList = [];
        // for (const itr of this.state.selectedReviewLists) {
        //   let rlName = this.state.apiResponse.find(
        //     (e) => e.reviewlist_id === itr
        //   );
        //   let reviewListItems = [];
        //   let _transaction_id = uuidv4();
        //   this.props.selectedResults.map((item) => {
        //     reviewListItems.push({
        //       ...item.detail,
        //       reviewListName: rlName.reviewlist_name,
        //       reviewListId: itr,
        //       transaction_id: _transaction_id,
        //       reviewListType: this.state.selectedTab === "0" ? "PubMed" : "Abstracts",
        //       username: username,
        //       lastCreatedDatehour: getCurrentDate()
        //     })
        //   })

        //   let pubmedReviewResponse = await this.insertPubmedReviewListData(reviewListItems, _transaction_id);
        //   if (!pubmedReviewResponse.errors) {
        //     await service.insertUpdatePubMedReviewList(
        //       rlName.reviewlist_name,
        //       itr,
        //       username,
        //       docIDs,
        //       this.state.notes
        //     );
        //     this.indexData(rlName.reviewlist_name, itr, docIDs, _transaction_id)
        //   } else {
        //     isValidReviewList = false;
        //     failedReviewList.push(rlName.reviewlist_name);
        //   }
        // }
        // this.setState({ isLoaded: true }, () => {
        //   if (!isValidReviewList) {
        //     this.errorAlertMessage(`Add to reviewlist failed due to some reason. Kindly try after some time.<br /><br /><p class='alertmessage-file-label'>Review list name</p> - ${failedReviewList.join("<br /> - ")}`)
        //   } else {
        //     this.setState({
        //       successMessage:
        //         "The result/selection was pinned successfully to selected existing Review List(s).",
        //       showSuccess: true,
        //       isInsertSuccess: true
        //     });
        //   }
        // });
      }
      if (
        this.state.reviewListName !== "" &&
        this.state.selectedReviewLists.length > 0 &&
        isValidReviewList
      ) {
        this.setState({
          successMessage:
            "The result/selection was pinned successfully to selected existing Review List(s) and the new review list.",
          showSuccess: true,
          isInsertSuccess: true
        });
      }
    }
  };

  insertPubmedReviewListData = async (reviewListItems, _transaction_id) => {
    let res = { errors: true }
    let data = {
      reviewListData: reviewListItems,
      newTransaction: _transaction_id
    }
    const _headers = {
      'Content-Type': 'application/json'
    };
    if (await Authentication.isAccessTokenAvailable()) {
      // No Authorization header provided, attach the default one
      const token = await Authentication.getAccessToken();
      _headers.Authorization = `Bearer ${token}`;
    }
    var url = `${_locationOrigin}${process.env.REACT_APP_IMS_API_PUBMED}reviewlist/iprld`
    await axios.post(url, data,
      {
        headers: _headers,
      }).then((response) => {
        res = response.data
      }).catch((error) => {
        console.log(error);
        res = { errors: true }
      })
    return res
  };
  handleSuccessClose = async (status) => {
    this.setState({
      showSuccess: status,
      //showPop: false,
      isManage: true,
      isPin: false,
      isinfo: false,
      isLoaded: false
    },
      async () => {
        let username = JSON.parse(
          localStorage.getItem("username")
        ).toLowerCase();
        let service = new ApiServices();
        let apiRes = await service.getPubMedReviewLists(username);
        this.setState(
          {
            apiResponse: apiRes,
          },
          async () => {
            await this.getPubMedReviewListsWithDocIds();
          }
        );
      });
    //this.props.handleClose(false);
  };
  render() {
    const { alertMessageModelColor, alertMessageContent, alertMessageShowModal, isInsertSuccess } = this.state;
    const { confirmMessageContent, confirmMessageShowModal } = this.state;
    if (this.props.width <= 600) {
      return (
        <>
          <Modal
            show={this.state.showPop}
            size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="popup-transition"
            scrollable={true}
          >
            <div>
              {this.state.isLoaded ? (
                <>
                  {(this.props.selectedResults &&
                    this.props.selectedResults.length > 0) ||
                    this.state.apiResponse.length > 0 ? (
                    <div
                      style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}
                    >
                      <Modal.Header
                        className="gsfModalHeader"
                        style={{ justifyContent: "left", padding: "0.5rem 0" }}
                      >
                        <div
                          style={{
                            textAlign: "center",
                            width: "100%",
                            paddingTop: "1%",
                          }}
                        >
                          <Modal.Title>
                            <div className="actionItem-headerPart">
                              {this.props.selectedResults.length > 0 &&
                               /* this.props.selectedResults.length <= 200 &&*/ !isInsertSuccess && (
                                  <div
                                    onClick={(e) => {
                                      this.setState({
                                        isPin: true,
                                        isManage: false,
                                        isinfo: true,
                                      });
                                    }}
                                    className={
                                      this.state.isPin
                                        ? "active-pin-features-button"
                                        : "pin-features-buttons"
                                    }
                                    style={{ margin: "1% 0" }}
                                  >
                                    <span>Pin to Review List</span>
                                  </div>
                                )}
                              <div
                                onClick={(e) => {
                                  this.setState({ isPin: false, isManage: true });
                                }}
                                className={
                                  this.state.isManage
                                    ? "active-pin-features-button"
                                    : "pin-features-buttons"
                                }
                                style={{
                                  margin: "1% 0",
                                }} /* className="active-pin-features-button" */
                              >
                                <span>View/Manage Review Lists</span>
                              </div>
                            </div>
                          </Modal.Title>
                        </div>
                      </Modal.Header>
                      <Modal.Body scrollable={true} style={{ height: "45vh" }}>
                        {this.state.isPin && (
                          <div>
                            {this.state.isLoaded ? (
                              <>
                                <span style={{ color: "black" }}>
                                  My Review Lists
                                </span>{" "}
                                :
                                {this.state.apiResponse.length > 0 ? (
                                  <span>
                                    <ul className="review-list-wrapper">
                                      {this.state.apiResponse.map((item) => {
                                        return (
                                          <li key={item.reviewlist_id}>
                                            <span>
                                              <input
                                                type="checkbox"
                                                value={item.reviewlist_id}
                                                className="review-list-checkbox-wrapper"
                                                onChange={e => this.handleCheckBox(e, item.docCount)}
                                              />
                                            </span>
                                            {item.reviewlist_name}
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </span>
                                ) : (
                                  <span>
                                    You currently do not have any review lists
                                    created.
                                    <br />
                                  </span>
                                )}
                                <br />
                                <div>
                                  Create A New Review List By Entering A Title
                                  Below:
                                </div>
                                <input
                                  type="text"
                                  placeholder="Type here"
                                  value={this.state.reviewListName}
                                  className="review-list-input-box"
                                  onChange={this.handleInput}
                                  onFocus={this.handleOnFocusInput}
                                />
                                <br />
                                <span className="length-info">Name with a maximum of 100 characters.</span>
                                <div className="errorInvalidName">
                                  {this.state.error["pinReviewList"]}
                                </div>
                                <br />
                                <div>
                                  Create Note for the Review List
                                  Below:
                                </div>
                                <textarea
                                  className="create-alert-text-area"
                                  placeholder="Enter your custom notes here."
                                  onChange={(e) => this.setState({ notes: e.target.value })}
                                  value={this.state.notes}
                                ></textarea>
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                        {this.state.isManage && (
                          <div>
                            {this.state.isLoaded ? (
                              <>
                                {this.state.apiResponse.length > 0 ? (
                                  <span>
                                    <table className="review-list-view-wrapper">
                                      <tr>
                                        <th style={{ color: "#333" }}>
                                          Review List Name
                                        </th>
                                        <th
                                          style={{
                                            textAlign: "center",
                                            color: "#333",
                                          }}
                                        >
                                          Actions
                                        </th>
                                      </tr>
                                      <tbody>
                                        {this.state.apiResponse.map((item) => {
                                          return (
                                            <tr key={item.reviewlist_id}>
                                              <td>{item.reviewlist_name}</td>
                                              <td
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                  width: "100%",
                                                  flexDirection: "column",
                                                }}
                                              >
                                                <span
                                                  onClick={(e) =>
                                                    this.handleOnClickView(
                                                      item.reviewlist_id,
                                                      item.reviewlist_name
                                                    )
                                                  }
                                                  title="View"
                                                  className="review-list-action-text"
                                                >
                                                  View
                                                </span>
                                                <span
                                                  onClick={(e) =>
                                                    this.handleRename(
                                                      item.reviewlist_id,
                                                      item.reviewlist_name,
                                                      item.reviewlist_note
                                                    )
                                                  }
                                                  title="Edit"
                                                  className="review-list-action-text"
                                                >
                                                  Edit
                                                </span>
                                                <span
                                                  onClick={() =>
                                                    this.setState({
                                                      shareModal: true,
                                                      shareReviewList: item
                                                    }
                                                    )}
                                                  title="Share"
                                                  className="review-list-action-text"
                                                >
                                                  Share
                                                </span>
                                                <span
                                                  title="Remove"
                                                  className="review-list-action-text"
                                                  onClick={(e) =>
                                                    this.handleRemove(
                                                      item.reviewlist_id
                                                    )
                                                  }
                                                >
                                                  Remove
                                                </span>
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                    {/*this.state.isinfo === false && <span className="length-info">To Pin/Create the 'Review list' select the items that should be maximum upto 200.</span>*/}
                                  </span>
                                ) : (
                                  <span>
                                    {" "}
                                    You currently do not have any review lists
                                    created.
                                  </span>
                                )}
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </Modal.Body>
                      {this.state.isPin ? (
                        <div className="pin-popup-button-wrapper">
                          {/* <div style={{margin:"1% 0"}}> */}
                          <button
                            className="pin-pop-up-button-cancel"
                            onClick={(e) => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          >
                            Cancel
                          </button>
                          {/* <Button text="Cancel" customColor="#000000" action={() => { this.setState({ showPop: false });this.props.handleClose(false); }} /> */}
                          {/* </div>
                    <div style={{margin:"1% 0"}}> */}
                          <button
                            className="pin-pop-up-button-proceed"
                            onClick={(e) => {
                              this.onclickProceed();
                            }}
                          >
                            Pin
                          </button>
                          {/* <Button text="Pin" customColor="#EB1700" action={this.onclickProceed} /> */}
                          {/* </div> */}
                        </div>
                      ) : (
                        <div className="pin-popup-button-wrapper">
                          <Button
                            text="Cancel" customColor="#000000"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ borderLeft: `5px solid #0074B0` }}>
                      {/* <div className="popup-cancel-btn-wrapper">
                        <img src={popCancelBttn} alt="" onClick={(e)=>{this.setState({showPop:false});this.props.handleClose(false)}}/>
                    </div> */}
                      <div style={{ padding: "0 5%" }}>
                        <Modal.Header
                          style={{
                            justifyContent: "center",
                            borderBottomColor: "#0074B0",
                          }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <Modal.Title>
                              <div>
                                <img
                                  src={exclaimIcn}
                                  alt=""
                                  className="popup-header-icon-wrapper"
                                />
                              </div>
                              <span style={{ color: "#0074B0" }}>
                                No Review Lists
                              </span>
                            </Modal.Title>
                          </div>
                        </Modal.Header>
                        <Modal.Body
                          scrollable={true}
                          style={{ minHeight: "35vh" }}
                        >
                          <div>
                            It looks like you don't have any review lists created
                            yet. Please use 'Pin' from the desired result/select a
                            few and then click on 'Review List' icon.
                          </div>
                        </Modal.Body>
                        <div style={{ textAlign: "center", padding: "3% 0" }}>
                          <Button
                            text="Close"
                            customColor="#0074B0"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div style={{ textAlign: "center", padding: "10%" }}>
                  <img
                    src={imsLoader}
                    alt="Loading Data"
                    style={{ width: "10%" }}
                  />
                </div>
              )}
            </div>
            {this.state.showSuccess && (
              <>
                <SucessReadingList
                  display={this.state.showSuccess}
                  handleClose={(status) => this.handleSuccessClose(status)}
                  data={this.state.successMessage}
                  width={this.props.width}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
            {this.state.showRenamePop && (
              <>
                <RenamePubMedReviewListPopup
                  showModal={this.state.showRenamePop}
                  handleClose={(status) => this.handleRenameClose(status)}
                  rlName={this.state.itemtoBeRenamedName}
                  rlID={this.state.itemtoBeRenamedID}
                  width={this.props.width}
                  apiResponse={this.state.apiResponse}
                  getAllReviewListData={this.props.getAllReviewListData}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
          </Modal>
          {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} />}
          {(this.state.shareModal) &&
            <SharePubMedModal

              showModal={this.state.shareModal}
              //handleShareThreadToUser={this.handleShareThreadToUser} 
              //handleIsProcessing={this.handleIsProcessing} 
              shareReviewList={this.state.shareReviewList}
              handleClose={() => this.setState({ shareModal: false })}
            />}
        </>
      );
    } else if (this.props.width <= 1000 && this.props.width > 600) {
      return (
        <>
          <Modal
            show={this.state.showPop}
            size="lg md sm xs"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="popup-transition"
            scrollable={true}
          >
            <div>
              {this.state.isLoaded ? (
                <>
                  {(this.props.selectedResults &&
                    this.props.selectedResults.length > 0) ||
                    this.state.apiResponse.length > 0 ? (
                    <div
                      style={{ borderTop: `5px solid #EB1700`, overflow: "auto" }}
                    >
                      <Modal.Header
                        className="gsfModalHeader"
                        style={{ justifyContent: "left", padding: "0.5rem 0" }}
                      >
                        <div
                          style={{
                            textAlign: "center",
                            width: "100%",
                            paddingTop: "1%",
                          }}
                        >
                          <Modal.Title>
                            <div className="actionItem-headerPart">
                              {this.props.selectedResults.length > 0 &&
                                /*this.props.selectedResults.length <= 200 && */ !isInsertSuccess && (
                                  <>
                                    <div
                                      onClick={(e) => {
                                        this.setState({
                                          isPin: true,
                                          isManage: false,
                                          isinfo: true,
                                        });
                                      }}
                                      className={
                                        this.state.isPin
                                          ? "active-pin-features-button"
                                          : "pin-features-buttons"
                                      }
                                      style={{ margin: "1% 0" }}
                                    >
                                      <span>Pin to Review List</span>
                                    </div>
                                    <div className="action-button-saperation-line"></div>
                                  </>
                                )}
                              <div
                                onClick={(e) => {
                                  this.setState({ isPin: false, isManage: true });
                                }}
                                className={
                                  this.state.isManage
                                    ? "active-pin-features-button"
                                    : "pin-features-buttons"
                                }
                                style={{
                                  margin: "1% 0",
                                }} /* className="active-pin-features-button" */
                              >
                                <span>View/Manage Review Lists</span>
                              </div>
                            </div>
                          </Modal.Title>
                        </div>
                      </Modal.Header>
                      <Modal.Body scrollable={true} style={{ height: "45vh" }}>
                        {this.state.isPin && (
                          <div>
                            {this.state.isLoaded ? (
                              <>
                                <span style={{ color: "black" }}>
                                  My Review Lists
                                </span>{" "}
                                :
                                {this.state.apiResponse.length > 0 ? (
                                  <span>
                                    <ul className="review-list-wrapper">
                                      {this.state.apiResponse.map((item) => {
                                        return (
                                          <li key={item.reviewlist_id}>
                                            <span>
                                              <input
                                                type="checkbox"
                                                value={item.reviewlist_id}
                                                className="review-list-checkbox-wrapper"
                                                onChange={e => this.handleCheckBox(e, item.docCount)}
                                              />
                                            </span>
                                            {item.reviewlist_name}
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </span>
                                ) : (
                                  <span>
                                    You currently do not have any review lists
                                    created.
                                    <br />
                                  </span>
                                )}
                                <br />
                                <div>
                                  Create A New Review List By Entering A Title
                                  Below:
                                </div>
                                <input
                                  type="text"
                                  placeholder="Type here"
                                  value={this.state.reviewListName}
                                  className="review-list-input-box"
                                  onChange={this.handleInput}
                                  onFocus={this.handleOnFocusInput}
                                />
                                <br />
                                <span className="length-info">Name with a maximum of 100 characters.</span>
                                <div className="errorInvalidName">
                                  {this.state.error["pinReviewList"]}
                                </div>
                                <br />
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                        {this.state.isManage && (
                          <div>
                            {this.state.isLoaded ? (
                              <>
                                {this.state.apiResponse.length > 0 ? (
                                  <span>
                                    <table className="review-list-view-wrapper">
                                      <tr>
                                        <th>Review List Name</th>
                                        <th style={{ textAlign: "center" }}>
                                          Date Saved
                                        </th>
                                        <th style={{ textAlign: "center" }}>
                                          Actions
                                        </th>
                                      </tr>
                                      <tbody>
                                        {this.state.apiResponse.map((item) => {
                                          return (
                                            <tr key={item.reviewlist_id}>
                                              <td>{item.reviewlist_name}</td>
                                              <td style={{ textAlign: "center" }}>
                                                {moment(item.added_on).format("D-MMM-YYYY")}
                                              </td>
                                              <td
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                  width: "100%",
                                                }}
                                              >
                                                <span
                                                  onClick={(e) =>
                                                    this.handleOnClickView(
                                                      item.reviewlist_id,
                                                      item.reviewlist_name
                                                    )
                                                  }
                                                  title="View"
                                                  className="review-list-action-text"
                                                >
                                                  View
                                                </span>
                                                <span className="action-items-separate-divider"></span>
                                                <span
                                                  onClick={(e) =>
                                                    this.handleRename(
                                                      item.reviewlist_id,
                                                      item.reviewlist_name,
                                                      item.reviewlist_note
                                                    )
                                                  }
                                                  title="Edit"
                                                  className="review-list-action-text"
                                                >
                                                  Edit
                                                </span>
                                                <span className="action-items-separate-divider"></span>
                                                <span
                                                  onClick={() => this.setState({ shareModal: true, shareReviewList: item })}
                                                  title="Share"
                                                  className="review-list-action-text"
                                                >
                                                  Share
                                                </span>
                                                <span className="action-items-separate-divider"></span>
                                                <span
                                                  title="Remove"
                                                  className="review-list-action-text"
                                                  onClick={(e) =>
                                                    this.handleRemove(
                                                      item.reviewlist_id
                                                    )
                                                  }
                                                >
                                                  Remove
                                                </span>
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                    {/*this.state.isinfo === false && <span className="length-info">To Pin/Create the 'Review list' select the items that should be maximum upto 200.</span>*/}
                                  </span>
                                ) : (
                                  <span>
                                    {" "}
                                    You currently do not have any review lists
                                    created.
                                  </span>
                                )}
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </Modal.Body>
                      {this.state.isPin ? (
                        <div
                          className="gsf-popup-button-wrapper"
                          style={{ width: "40%" }}
                        >
                          <Button
                            text="Cancel" customColor="#000000"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                          <Button
                            text="Pin"
                            customColor="#EB1700"
                            action={this.onclickProceed}
                          />
                        </div>
                      ) : (
                        <div className="review-list-button-tablet-wrapper">
                          <Button
                            text="Cancel" customColor="#000000"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ borderLeft: `5px solid #0074B0` }}>
                      {/* <div className="popup-cancel-btn-wrapper">
                        <img src={popCancelBttn} alt="" onClick={(e)=>{this.setState({showPop:false});this.props.handleClose(false)}}/>
                    </div> */}
                      <div style={{ padding: "0 5%" }}>
                        <Modal.Header
                          style={{
                            justifyContent: "center",
                            borderBottomColor: "#0074B0",
                          }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <Modal.Title>
                              <div>
                                <img
                                  src={exclaimIcn}
                                  alt=""
                                  className="popup-header-icon-wrapper"
                                />
                              </div>
                              <span style={{ color: "#0074B0" }}>
                                No Review Lists
                              </span>
                            </Modal.Title>
                          </div>
                        </Modal.Header>
                        <Modal.Body
                          scrollable={true}
                          style={{ minHeight: "35vh" }}
                        >
                          <div>
                            It looks like you don't have any review lists created
                            yet. Please use 'Pin' from the desired result/select a
                            few and then click on 'Review List' icon.
                          </div>
                        </Modal.Body>
                        <div style={{ textAlign: "center", padding: "3% 0" }}>
                          <Button
                            text="Close"
                            customColor="#0074B0"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div style={{ textAlign: "center", padding: "10%" }}>
                  <img
                    src={imsLoader}
                    alt="Loading Data"
                    style={{ width: "10%" }}
                  />
                </div>
              )}
            </div>
            {this.state.showSuccess && (
              <>
                <SucessReadingList
                  display={this.state.showSuccess}
                  handleClose={(status) => this.handleSuccessClose(status)}
                  data={this.state.successMessage}
                  width={this.props.width}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
            {this.state.showRenamePop && (
              <>
                <RenamePubMedReviewListPopup
                  showModal={this.state.showRenamePop}
                  handleClose={(status) => this.handleRenameClose(status)}
                  rlName={this.state.itemtoBeRenamedName}
                  rlID={this.state.itemtoBeRenamedID}
                  width={this.props.width}
                  apiResponse={this.state.apiResponse}
                  getAllReviewListData={this.props.getAllReviewListData}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
          </Modal>
          {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} />}
          {(this.state.shareModal) &&
            <SharePubMedModal

              showModal={this.state.shareModal}
              //handleShareThreadToUser={this.handleShareThreadToUser} 
              //handleIsProcessing={this.handleIsProcessing} 
              handleClose={() => this.setState({ shareModal: false })}
              shareReviewList={this.state.shareReviewList}
            />}
        </>
      );
    } else {
      return (
        <>
          <Modal
            show={this.state.showPop}
            size="xl"
            centered
            aria-labelledby="contained-modal-title-vcenter"
            dialogClassName="popup-transition modal-95w"
            scrollable={true}
          >
            <div >
              <div className="popup-cancel-btn-wrapper">
                <img
                  src={popCancelBttn}
                  alt=""
                  onClick={(e) => {
                    this.setState({ showPop: false });
                    this.props.handleClose(false);
                  }}
                />
              </div>
              {this.state.isLoaded ? (
                <>
                  {(this.props.selectedResults &&
                    this.props.selectedResults.length > 0) ||
                    this.state.apiResponse.length > 0 ? (
                    <div
                      style={{
                        borderTop: `5px solid #EB1700`,
                        overflow: "auto"
                      }}
                    >
                      <Modal.Header
                        className="gsfModalHeader"
                        style={{ justifyContent: "left" }}
                      >
                        <div
                          style={{
                            textAlign: "center",
                            width:
                              this.props.selectedResults.length > 0 /*&&
                                this.props.selectedResults.length <= 200*/
                                ? "60%"
                                : "30%",
                            paddingTop: "1%",
                          }}
                        >
                          <Modal.Title>
                            <div className="actionItem-headerPart" style={isInsertSuccess ? { justifyContent: "flex-start" } : {}}>
                              {this.props.selectedResults.length > 0 &&
                                /*this.props.selectedResults.length <= 200 &&*/ !isInsertSuccess && (
                                  <>
                                    <div
                                      onClick={(e) => {
                                        this.setState({
                                          isPin: true,
                                          isManage: false,
                                          isinfo: true,
                                        });
                                      }}
                                      className={
                                        this.state.isPin
                                          ? "active-features-button"
                                          : "features-buttons"
                                      }
                                    >
                                      <span>Pin to Review List</span>
                                    </div>
                                    <div className="action-button-saperation-line"></div>
                                  </>
                                )}
                              <div
                                onClick={(e) => {
                                  this.setState({ isPin: false, isManage: true });
                                }}
                                className={
                                  this.state.isManage
                                    ? "active-features-button"
                                    : "features-buttons"
                                } /* className="active-features-button" */
                              >
                                <span>View/Manage Review Lists</span>
                              </div>
                            </div>
                          </Modal.Title>
                        </div>
                      </Modal.Header>
                      <Modal.Body scrollable={true} style={{
                        height: "44vh"
                      }}>
                        {this.state.isPin && (
                          <div>
                            {this.state.isLoaded ? (
                              <>
                                <span style={{ color: "black" }}>
                                  My Review Lists
                                </span>{" "}
                                :
                                {this.state.apiResponse.length > 0 ? (
                                  <span>
                                    <ul className="review-list-wrapper">
                                      {this.state.apiResponse.map((item) => {
                                        return (
                                          <li
                                            className="reviewlistCheckBox"
                                            key={item.reviewlist_id}
                                          >
                                            <span>
                                              <input
                                                type="checkbox"
                                                value={item.reviewlist_id}
                                                className="review-list-checkbox-wrapper"
                                                onChange={e => this.handleCheckBox(e, item.docCount)}
                                              />
                                            </span>
                                            {item.reviewlist_name}
                                          </li>
                                        );
                                      })}
                                    </ul>
                                  </span>
                                ) : (
                                  <span>
                                    You currently do not have any review lists
                                    created.
                                    <br />
                                  </span>
                                )}
                                <br />
                                <div>
                                  Create A New Review List By Entering A Title
                                  Below:
                                </div>
                                <input
                                  type="text"
                                  placeholder="Type here"
                                  value={this.state.reviewListName}
                                  className="review-list-input-box"
                                  onFocus={this.handleOnFocusInput}
                                  onChange={this.handleInput}
                                />
                                <br />
                                <span className="length-info">Name with a maximum of 100 characters.</span>
                                <div className="errorInvalidName">
                                  {this.state.error["pinReviewList"]}
                                </div>
                                <br />
                                <div>
                                  Create Note for the Review List
                                  Below:
                                </div>
                                <textarea
                                  className="create-alert-text-area"
                                  placeholder="Enter your custom notes here."
                                  onChange={(e) => this.setState({ notes: e.target.value })}
                                  value={this.state.notes}
                                ></textarea>
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                        {this.state.isManage && (
                          <div>
                            {this.state.isLoaded ? (
                              <>
                                {this.state.apiResponse.length > 0 ? (
                                  <span>
                                    <table className="review-list-view-wrapper">
                                      <tr>
                                        <th style={{ width: '150px' }}>Review List Name</th>
                                        <th>
                                          Notes
                                        </th>
                                        <th style={{ width: '100px', textAlign: "center" }}>
                                          Date Saved
                                        </th>
                                        <th style={{ width: '200px', textAlign: "center" }}>
                                          Shared By
                                        </th>
                                        <th style={{ width: '200px', textAlign: "center" }}>
                                          Actions
                                        </th>
                                      </tr>
                                      <tbody>
                                        {this.state.apiResponse.map((item) => {
                                          return (
                                            <tr key={item.reviewlist_id}>
                                              <td className="reviewList-width-name" title={item.reviewlist_name} ><div className="reviewList-Name">{item.reviewlist_name} </div></td>
                                              <td className="reviewList-width-note" title={item.reviewlist_note}><div className="reviewList-Note">{item.reviewlist_note}</div></td>
                                              <td style={{ textAlign: "center" }}>
                                                {moment(item.added_on).format("D-MMM-YYYY")}
                                              </td>
                                              <td style={{ textAlign: "center" }}>
                                                <p style={{ margin: 0 }}>{item.shared_from_name && `Name: ${item.shared_from_name}`}</p>
                                                <p style={{ margin: 0 }}> {item.shared_from_email && `Email Id: ${item.shared_from_email}`}</p>
                                              </td>
                                              <td
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "center",
                                                  alignItems: "center",
                                                  cursor: "pointer",
                                                  width: "100%",
                                                }}
                                              >
                                                <span
                                                  onClick={(e) =>
                                                    this.handleOnClickView(
                                                      item.reviewlist_id,
                                                      item.reviewlist_name
                                                    )
                                                  }
                                                  title="View"
                                                  className="review-list-action-text"
                                                >
                                                  View
                                                </span>
                                                <span className="action-items-separate-divider"></span>
                                                <span
                                                  onClick={(e) =>
                                                    this.handleRename(
                                                      item.reviewlist_id,
                                                      item.reviewlist_name,
                                                      item.reviewlist_note
                                                    )
                                                  }
                                                  title="Edit"
                                                  className="review-list-action-text"
                                                >
                                                  Edit
                                                </span>
                                                <span className="action-items-separate-divider"></span>
                                                <span
                                                  onClick={() => this.setState({ shareModal: true, shareReviewList: item })}
                                                  title="Share"
                                                  className="review-list-action-text"
                                                >
                                                  Share
                                                </span>
                                                <span className="action-items-separate-divider"></span>
                                                <span
                                                  title="Remove"
                                                  className="review-list-action-text"
                                                  onClick={(e) =>
                                                    this.handleRemove(
                                                      item.reviewlist_id
                                                    )
                                                  }
                                                >
                                                  Remove
                                                </span>
                                              </td>
                                            </tr>
                                          );
                                        })}
                                      </tbody>
                                    </table>
                                    {/*this.state.isinfo === false && <span className="length-info">To Pin/Create the 'Review list' select the items that should be maximum upto 200.</span>*/}
                                  </span>
                                ) : (
                                  <span>
                                    {" "}
                                    You currently do not have any review lists
                                    created.
                                  </span>
                                )}
                              </>
                            ) : (
                              <div
                                style={{ textAlign: "center", padding: "10%" }}
                              >
                                <img
                                  src={imsLoader}
                                  alt="Loading Data"
                                  style={{ width: "10%" }}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </Modal.Body>
                      {this.state.isPin ? (
                        <div className="gsf-popup-button-wrapper">
                          <Button
                            text="Cancel" customColor="#000000"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />

                          <Button
                            text="Pin"
                            customColor="#EB1700"
                            action={this.onclickProceed}
                          />
                        </div>
                      ) : (
                        <div className="review-list-button-wrapper">
                          <Button
                            text="Cancel" customColor="#000000"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                        </div>
                      )}
                    </div>
                  ) : (
                    <div style={{ borderLeft: `5px solid #0074B0` }}>
                      <div className="popup-cancel-btn-wrapper">
                        <img
                          src={popCancelBttn}
                          alt=""
                          onClick={(e) => {
                            this.setState({ showPop: false });
                            this.props.handleClose(false);
                          }}
                        />
                      </div>
                      <div style={{ padding: "0 5%" }}>
                        <Modal.Header
                          style={{
                            justifyContent: "center",
                            borderBottomColor: "#0074B0",
                          }}
                        >
                          <div style={{ textAlign: "center" }}>
                            <Modal.Title>
                              <div>
                                <img
                                  src={exclaimIcn}
                                  alt=""
                                  className="popup-header-icon-wrapper"
                                />
                              </div>
                              <span style={{ color: "#0074B0" }}>
                                No Review Lists
                              </span>
                            </Modal.Title>
                          </div>
                        </Modal.Header>
                        <Modal.Body
                          scrollable={true}
                          style={{ minHeight: "25vh" }}
                        >
                          <div>
                            It looks like you don't have any review lists created
                            yet. Please use 'Pin' from the desired result/select a
                            few and then click on 'Review List' icon.
                          </div>
                        </Modal.Body>
                        <div style={{ textAlign: "center", padding: "3% 0" }}>
                          <Button
                            text="Close"
                            customColor="#0074B0"
                            action={() => {
                              this.setState({ showPop: false });
                              this.props.handleClose(false);
                            }}
                          />
                        </div>
                      </div>
                    </div>
                  )}
                </>
              ) : (
                <div style={{ textAlign: "center", padding: "10%" }}>
                  <img
                    src={imsLoader}
                    alt="Loading Data"
                    style={{ width: "10%" }}
                  />
                </div>
              )}
            </div>
            {this.state.showSuccess && (
              <>
                <SucessReadingList
                  display={this.state.showSuccess}
                  handleClose={(status) => this.handleSuccessClose(status)}
                  data={this.state.successMessage}
                  width={this.props.width}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
            {this.state.showRenamePop && (
              <>
                <RenamePubMedReviewListPopup
                  showModal={this.state.showRenamePop}
                  handleClose={(status) => this.handleRenameClose(status)}
                  rlName={this.state.itemtoBeRenamedName}
                  rlID={this.state.itemtoBeRenamedID}
                  notes={this.state.notes}
                  width={this.props.width}
                  apiResponse={this.state.apiResponse}
                  getAllReviewListData={this.props.getAllReviewListData}
                  handleReviewNameTitle={this.props.handleReviewNameTitle}
                />
                <div className="savemodal-outer-wrapper"></div>
              </>
            )}
          </Modal>
          {alertMessageShowModal && <AlertMessagePopUpModal color={alertMessageModelColor} content={alertMessageContent} showModal={alertMessageShowModal} handleClose={() => this.closeAlertMessage()} />}
          {confirmMessageShowModal && <ConfirmMessagePopUpModal content={confirmMessageContent} showModal={confirmMessageShowModal} handleClose={() => this.closeConfirmMessage()} handleConfirm={() => this.confirmHandler()} />}
          {(this.state.shareModal) &&
            <SharePubMedModal
              showModal={this.state.shareModal}
              //handleShareThreadToUser={this.handleShareThreadToUser} 
              //handleIsProcessing={this.handleIsProcessing} 
              shareReviewList={this.state.shareReviewList}
              handleClose={() => this.setState({ shareModal: false })}
              shareFrom={{ 'fromSaveSearch': false, 'fromReviewList': true }}
            />}
        </>
      );
    }
  }
}
export default PubMedReviewListPopup;
